import * as Diagram from "../../../../components/diagram";
import { formatLevelColumns } from "../../../fromatApiRes";

export const HealthManagementStatisticsReport = {
  label: "健康管理統計報表",
  key: "HealthManagementStatisticsReport",
  path: "HealthManagement/HealthManagementStatisticsReport",
  api: "TCS_V_HealthCare",
  render: (options) => (
    <Diagram.HealthManagement.HealthManagementStatisticsReport {...options} />
  ),
  isRaw: true,
  isPage: true,
  page: null,
  isGroup: true,
  groupColumns: [
    {
      key: "type",
      field: "type",
      header: "",
    },
    {
      key: "status",
      field: "status",
      header: "分類結果",
    },
  ],
  categoryColumns: [
    { key: "年齡", type: "string" },
    { key: "SEX", type: "string" },
  ],
  otherColumns: {
    groupColumns: {
      type: [
        "血壓",
        "血糖",
        "血脂",
        "三酸甘油脂",
        "總膽固醇",
        "高密度脂蛋白",
        "低密度脂蛋白",
      ],
      status: ["正常", "異常", "無法判別"],
    },
  },
  filterColumns: [{ key: "EXMDAT", label: "健檢日期", type: "date" }],
  columns: [
    {
      key: "total",
      field: "total_format",
      header: "總人數",
    },
  ],
};
